(() => {
  const SELECTOR = '[data-ff-header]';
  const Intelligence = window.ForeFrontSearchIntelligence;

  const QUICK_LINKS = [
    { label: 'Find labels and ink for my printer', url: '/pages/inkjet-label-ink-finder' },
    { label: 'Shop inkjet label rolls', url: '/collections/inkjet-labels' },
    { label: 'Shop colour label printers', url: '/collections/color-label-printers' },
    { label: 'Reorder ink and maintenance supplies', url: '/collections/inks-toners' },
    { label: 'Talk to a label specialist', url: '/pages/contact-us' }
  ];

  const normalizeSearchText = (value) => Intelligence
    ? Intelligence.normalizeSearchText(value)
    : String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

  const PRODUCT_DETAIL_CACHE = new Map();
  const COLLECTION_IMAGE_CACHE = new Map();
  let SEARCH_INSTANCE_COUNT = 0;
  const productPath = (item) => String(item?.url || (item?.handle ? '/products/' + item.handle : '')).split('?')[0];
  const productImageUrl = (item) => {
    const candidates = [item?.featured_image?.url, item?.featured_image, item?.image?.url, item?.image, item?.images?.[0]?.src, item?.images?.[0]];
    return candidates.find((value) => typeof value === 'string' && value.trim()) || '';
  };
  const loadProductDetail = (handle) => {
    if (!handle) return Promise.resolve(null);
    if (PRODUCT_DETAIL_CACHE.has(handle)) return PRODUCT_DETAIL_CACHE.get(handle);
    const request = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => { if (!response.ok) throw new Error('Product detail request failed'); return response.json(); })
      .catch(() => null);
    PRODUCT_DETAIL_CACHE.set(handle, request);
    return request;
  };

  const loadCollectionImage = (url) => {
    const collectionPath = String(url || '').split('?')[0];
    const handle = (collectionPath.match(/^\/collections\/([^/]+)/) || [])[1];
    if (!handle) return Promise.resolve('');
    if (COLLECTION_IMAGE_CACHE.has(handle)) return COLLECTION_IMAGE_CACHE.get(handle);
    const request = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=1', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => { if (!response.ok) throw new Error('Collection image request failed'); return response.json(); })
      .then((payload) => productImageUrl(payload?.products?.[0]))
      .catch(() => '');
    COLLECTION_IMAGE_CACHE.set(handle, request);
    return request;
  };

  const EXACT_PRINTER_MATCHES = [
    { model: 'c7500g', aliases: ['c7500g', '7500g'], label: 'Epson ColorWorks C7500G Labels', url: '/collections/epson-tm-c7500g-labels', meta: 'Epson ColorWorks compatible labels' },
    { model: 'c7500', aliases: ['c7500', '7500'], label: 'Epson ColorWorks C7500 Labels', url: '/collections/epson-c7500-labels', meta: 'Epson ColorWorks compatible labels' },
    { model: 'c3500', aliases: ['c3500', '3500', 'tm c3500', 'tmc3500'], label: 'Epson TM-C3500 Labels', url: '/collections/epson-tm-c3500-labels', meta: 'Epson ColorWorks compatible labels' },
    { model: 'c3400', aliases: ['c3400', '3400', 'tm c3400', 'tmc3400'], label: 'Epson TM-C3400 Labels', url: '/collections/epson-tm-c3400-labels', meta: 'Epson ColorWorks compatible labels' },
    { model: 'c4000', aliases: ['c4000', 'cw c4000'], label: 'Epson ColorWorks C4000 Labels', url: '/collections/epson-cw-c4000-labels', meta: 'Epson ColorWorks compatible labels' },
    { model: 'd3800', aliases: ['d3800', '3800'], label: 'Epson ColorWorks CW-D3800 Color Label Printer', url: '/products/epson-colorworks-cw-d3800-color-label-printer', meta: 'New colour label printer · Coming Soon', searchQuery: 'Epson CW-D3800' },
    { model: 'c6000', aliases: ['c6000', 'cw c6000'], label: 'Epson ColorWorks C6000 Labels', url: '/collections/epson-cw-c6000-labels', meta: 'Epson ColorWorks compatible labels' },
    { model: 'c6500', aliases: ['c6500', 'cw c6500'], label: 'Epson ColorWorks C6500 Labels', url: '/collections/epson-cw-c6500-labels', meta: 'Epson ColorWorks compatible labels' },
    { model: 'c8000', aliases: ['c8000', 'cw c8000'], label: 'Epson ColorWorks C8000 Labels', url: '/collections/epson-cw-c8000', meta: 'Epson ColorWorks compatible labels' },
    { model: 'lx400', label: 'Primera LX400 Labels', url: '/collections/primera-lx400-labels', meta: 'Primera compatible labels' },
    { model: 'lx500', label: 'Primera LX500 Labels', url: '/collections/primera-lx500-labels', meta: 'Primera compatible labels' },
    { model: 'lx600', label: 'Primera LX600 Labels', url: '/collections/primera-lx600-labels', meta: 'Primera compatible labels' },
    { model: 'lx610', label: 'Primera LX610 Labels', url: '/collections/primera-lx610-labels', meta: 'Primera compatible labels' },
    { model: 'lx800', label: 'Primera LX800 Labels', url: '/collections/primera-lx800-labels', meta: 'Primera compatible labels' },
    { model: 'lx810', label: 'Primera LX810 Labels', url: '/collections/primera-lx810-labels', meta: 'Primera compatible labels' },
    { model: 'lx900', label: 'Primera LX900 Labels', url: '/collections/primera-lx900-labels', meta: 'Primera compatible labels' },
    { model: 'lx910', label: 'Primera LX910 Labels', url: '/collections/primera-lx910-labels', meta: 'Primera compatible labels' },
    { model: 'lx1000', label: 'Primera LX1000 Labels', url: '/collections/primera-lx1000-labels', meta: 'Primera compatible labels' },
    { model: 'lx2000', label: 'Primera LX2000 Labels', url: '/collections/primera-lx2000-labels', meta: 'Primera compatible labels' },
    { model: 'lx3000', label: 'Primera LX3000 Labels', url: '/collections/primera-lx3000-labels', meta: 'Primera compatible labels' },
    { model: 'lx4000', label: 'Primera LX4000 Labels', url: '/collections/primera-lx4000-labels', meta: 'Primera compatible labels' },
    { model: 'l301', label: 'Afinia L301 Labels', url: '/collections/afinia-l301-labels', meta: 'Afinia compatible labels' },
    { model: 'l501', label: 'Afinia L501 Labels', url: '/collections/afinia-l501-labels', meta: 'Afinia compatible labels' },
    { model: 'l502', label: 'Afinia L502 Labels', url: '/collections/afinia-l502-labels', meta: 'Afinia compatible labels' },
    { model: 'l701', label: 'Afinia L701 Labels', url: '/collections/afinia-l701-labels', meta: 'Afinia compatible labels' },
    { model: 'l801', label: 'Afinia L801 Labels', url: '/collections/afinia-l801-labels', meta: 'Afinia compatible labels' },
    { model: 'l901', label: 'Afinia L901 Labels', url: '/collections/afinia-l901-labels', meta: 'Afinia compatible labels' },
    { model: 'vp485', label: 'VIPColor VP485 Labels', url: '/collections/vipcolor-vp485-labels', meta: 'VIPColor compatible labels' },
    { model: 'vp495', label: 'VIPColor VP495 Labels', url: '/collections/vipcolor-vp495-labels', meta: 'VIPColor compatible labels' },
    { model: 'vp500', label: 'VIPColor VP500 Labels', url: '/collections/vipcolor-vp500-labels', meta: 'VIPColor compatible labels' },
    { model: 'vp550', label: 'VIPColor VP550 Labels', url: '/collections/vipcolor-vp550-labels', meta: 'VIPColor compatible labels' },
    { model: 'vp600', label: 'VIPColor VP600 Labels', url: '/collections/vipcolor-vp600-labels', meta: 'VIPColor compatible labels' },
    { model: 'vp610', label: 'VIPColor VP610 Labels', url: '/collections/vipcolor-vp610-labels', meta: 'VIPColor compatible labels' },
    { model: 'vp650', label: 'VIPColor VP650 Labels', url: '/collections/vipcolor-vp650-labels', meta: 'VIPColor compatible labels' },
    { model: 'vp660', label: 'VIPColor VP660 Labels', url: '/collections/vipcolor-vp660-labels', meta: 'VIPColor compatible labels' },
    { model: 'vp700', label: 'VIPColor VP700 Labels', url: '/collections/vipcolor-vp700-labels', meta: 'VIPColor compatible labels' },
    { model: 'vp750', label: 'VIPColor VP750 Labels', url: '/collections/vipcolor-vp750-labels', meta: 'VIPColor compatible labels' },
    { model: 'c4000', label: 'Epson ColorWorks CW-C4000 Color Label Printer', url: '/products/epson-colorworks-cw-c4000-color-label-printer' },
    { model: 'c6000', label: 'Compare Epson ColorWorks CW-C6000 Printers', url: '/collections/epson-label-printers' },
    { model: 'c6500', label: 'Compare Epson ColorWorks CW-C6500 Printers', url: '/collections/epson-label-printers' }
  ];
  const findExactPrinter = (query) => {
    if (Intelligence) return Intelligence.findPrinter(query);
    const compactQuery = normalizeSearchText(query).replace(/\s+/g, '');
    const exact = EXACT_PRINTER_MATCHES.find((item) => (item.aliases || [item.model]).some((alias) => compactQuery.includes(normalizeSearchText(alias).replace(/\s+/g, ''))));
    if (exact) return exact;

    const tokens = normalizeSearchText(query).split(' ').filter((token) => token.length >= 3);
    return EXACT_PRINTER_MATCHES.find((item) => (item.aliases || [item.model]).some((alias) => {
      const compactAlias = normalizeSearchText(alias).replace(/\s+/g, '');
      if (compactAlias.length < 4) return false;
      return tokens.some((token) => Math.abs(token.length - compactAlias.length) <= 1 && editDistance(token, compactAlias) <= 1);
    }));
  };


  const compactSearchText = (value) => normalizeSearchText(value).replace(/\s+/g, '');

  const editDistance = (left, right) => {
    const a = compactSearchText(left);
    const b = compactSearchText(right);
    const row = Array.from({ length: b.length + 1 }, (_, index) => index);
    for (let i = 1; i <= a.length; i += 1) {
      let previous = row[0];
      row[0] = i;
      for (let j = 1; j <= b.length; j += 1) {
        const saved = row[j];
        row[j] = Math.min(
          row[j] + 1,
          row[j - 1] + 1,
          previous + (a[i - 1] === b[j - 1] ? 0 : 1)
        );
        previous = saved;
      }
    }
    return row[b.length];
  };

  const findClosestPrinters = (query, limit = 3) => {
    const compactQuery = compactSearchText(query);
    if (compactQuery.length < 3) return [];

    const seen = new Set();
    const registry = Intelligence ? Intelligence.PRINTERS.map((printer) => ({
      ...printer,
      label: Intelligence.labelCollectionTitle(printer),
      url: printer.collection,
      meta: printer.generalCollection ? 'Browse the complete inkjet label collection' : printer.brand + ' compatible labels'
    })) : EXACT_PRINTER_MATCHES;
    return registry
      .map((item, index) => {
        const keys = item.aliases || [item.model];
        const score = Math.min(...keys.map((key) => {
          const compactKey = compactSearchText(key);
          if (compactKey === compactQuery) return 0;
          if (compactKey.includes(compactQuery) || compactQuery.includes(compactKey)) return 1;
          if (compactKey.startsWith(compactQuery) || compactQuery.startsWith(compactKey)) return 2;
          return editDistance(compactKey, compactQuery) + 3;
        }));
        return { item, score, index };
      })
      .sort((left, right) => left.score - right.score || left.index - right.index)
      .filter(({ item, score }) => {
        if (score > 5 || seen.has(item.model)) return false;
        seen.add(item.model);
        return true;
      })
      .slice(0, limit)
      .map(({ item }) => item);
  };

  const normalizeShopifyQuery = (query) => {
    let normalized = String(Intelligence ? Intelligence.cleanQuery(query).cleaned : query || '').trim().replace(/[\"″]/g, '');
    normalized = normalized
      .replace(/(\d+(?:\.\d+)?)\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)\s*gb\b/gi, '$1 x $2 gloss BOPP')
      .replace(/(\d+(?:\.\d+)?)\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)\s*mb\b/gi, '$1 x $2 matte BOPP')
      .replace(/(\d+(?:\.\d+)?)\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)\s*gp\b/gi, '$1 x $2 gloss paper')
      .replace(/(\d+(?:\.\d+)?)\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)\s*mp\b/gi, '$1 x $2 matte paper')
      .replace(/(\d+(?:\.\d+)?)\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)\s*g\b/gi, '$1 x $2 gloss')
      .replace(/(\d+(?:\.\d+)?)\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)\s*m\b/gi, '$1 x $2 matte')
      .replace(/(\d+(?:\.\d+)?)\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)/gi, '$1 x $2');
    normalized = normalized.replace(/\bmatte plastic\b/gi, 'matte BOPP');
    normalized = normalized.replace(/\bgloss plastic\b/gi, 'gloss BOPP');
    normalized = normalized.replace(/\bwaterproof labels?\b/gi, 'BOPP labels');
    return normalized;
  };
  const isLabelSizeQuery = (query) => /\d+(?:\.\d+)?\s+x\s+\d+(?:\.\d+)?/i.test(normalizeShopifyQuery(query));

  const exactSizeSearchQuery = (query) => {
    const normalized = normalizeShopifyQuery(query);
    const match = normalized.match(/(\d+(?:\.\d+)?)\s+x\s+(\d+(?:\.\d+)?)/i);
    if (!match) return normalized;
    return normalized.replace(match[0], '"' + match[1] + ' x ' + match[2] + '"');
  };

  function searchScore(item, query) {
    const title = normalizeSearchText(item.title);
    const q = normalizeSearchText(query);
    let score = title === q ? 0 : title.startsWith(q) ? 1 : title.includes(q) ? 2 : 5;
    const modelNumber = (q.match(/\b(?:c|d)?(\d{4})[a-z]?\b/) || [])[1];
    const isPrinter = /printer/.test(title) && !/ink|cartridge|maintenance|labels?|rolls?/.test(title);
    const isInk = /ink|cartridge|sjic|maintenance/.test(title);
    const isLabel = /labels?|rolls?|bopp|paper/.test(title);
    if (modelNumber && title.includes(modelNumber)) {
      if (isPrinter) score -= 100;
      else if (isInk) score -= 80;
      else if (isLabel) score -= 60;
    }
    if (/\bc[46]\d{3}\b/.test(q) && isPrinter) score -= 3;
    if (/ink|cartridge|sjic/.test(q) && /ink|cartridge|sjic/.test(title)) score -= 1;
    if (/label|roll|bopp|paper/.test(q) && /label|roll|bopp|paper/.test(title)) score -= 1;
    return score;
  }

  function initSearch(form) {
    if (form.dataset.ffSearchReady === 'true') return;
    form.dataset.ffSearchReady = 'true';
    const input = form.querySelector('input[name="q"]');
    const panel = form.querySelector('[data-ff-search-results]') || form.parentElement?.querySelector('[data-ff-search-results]');
    if (!input || !panel) return;

    const searchInstanceId = ++SEARCH_INSTANCE_COUNT;
    if (!panel.id) panel.id = 'ffx-search-results-' + searchInstanceId;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Search suggestions');
    panel.tabIndex = -1;

    let debounceTimer;
    let requestController;
    let activeOptionIndex = -1;
    const suggestionCache = new Map();
    const status = document.createElement('span');
    status.className = 'visually-hidden';
    status.dataset.ffSearchStatus = '';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    form.appendChild(status);
    const optionLinks = () => Array.from(panel.querySelectorAll('[data-ff-search-option]'));
    const announce = (message) => { status.textContent = ''; window.requestAnimationFrame(() => { status.textContent = message; }); };
    const clearActiveOption = () => {
      optionLinks().forEach((option) => { option.setAttribute('aria-selected', 'false'); option.classList.remove('is-active'); });
      activeOptionIndex = -1;
      input.removeAttribute('aria-activedescendant');
    };
    const setActiveOption = (index) => {
      const options = optionLinks();
      if (!options.length) { clearActiveOption(); return; }
      activeOptionIndex = (index + options.length) % options.length;
      options.forEach((option, optionIndex) => {
        const selected = optionIndex === activeOptionIndex;
        option.setAttribute('aria-selected', String(selected));
        option.classList.toggle('is-active', selected);
      });
      input.setAttribute('aria-activedescendant', options[activeOptionIndex].id);
      options[activeOptionIndex].scrollIntoView({ block: 'nearest' });
    };
    const close = () => { window.clearTimeout(debounceTimer); requestController?.abort(); panel.hidden = true; input.setAttribute('aria-expanded', 'false'); clearActiveOption(); };
    const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const registerOption = (link) => {
      link.id = panel.id + '-option-' + (optionLinks().length + 1);
      link.dataset.ffSearchOption = '';
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');
      link.tabIndex = -1;
      link.addEventListener('mouseenter', () => setActiveOption(optionLinks().indexOf(link)));
      return link;
    };
    const addHeading = (text) => {
      const heading = document.createElement('p');
      heading.className = 'ffx-search-results__heading';
      heading.setAttribute('role', 'presentation');
      heading.textContent = text;
      panel.appendChild(heading);
    };
    const themeAsset = (filename) => {
      const image = document.querySelector('img[src*=\"' + filename + '\"]');
      const scriptSource = document.querySelector('script[src*=\"ff-header.js\"]')?.src || '';
      const directAsset = scriptSource ? scriptSource.replace(/ff-header\.js(?:\?.*)?$/, filename) : '';
      const logo = document.querySelector('img[src*=\"ff-logo.webp\"], .ffx-header__logo img, img[alt*=\"ForeFront\"]');
      return image?.currentSrc || image?.src || directAsset || logo?.currentSrc || logo?.src || '';
    };
    const searchFallbackImage = (label, url) => {
      const value = normalizeSearchText(String(label || '') + ' ' + String(url || ''));
      if (/\bink\b|cartridge|maintenance|toner|ribbon/.test(value)) return themeAsset('ff-menu-inks.webp');
      if (/printer/.test(value) || (/(epson|primera|afinia|vipcolor|colorworks)/.test(value) && !/labels?|rolls?/.test(value))) return themeAsset('ff-menu-printer.webp');
      if (/labels?|rolls?|bopp|paper|collection/.test(value)) return themeAsset('ff-menu-labels.webp');
      return themeAsset('ff-logo.webp');
    };
    const searchImageUrl = (value) => {
      const source = String(value || '');
      if (!source || !/cdn\.shopify\.com/.test(source) || /[?&]width=/.test(source)) return source;
      return source + (source.includes('?') ? '&' : '?') + 'width=104';
    };
    const addLink = (label, url, meta, imageUrl) => {
      const link = document.createElement('a');
      link.className = 'ffx-search-result';
      link.href = url;
      const resolvedImageUrl = imageUrl || searchFallbackImage(label, url);
      if (resolvedImageUrl) {
        const image = document.createElement('img');
        image.src = searchImageUrl(resolvedImageUrl);
        image.alt = '';
        image.width = 52;
        image.height = 52;
        image.loading = 'eager';
        image.decoding = 'async';
        link.appendChild(image);
      }
      const copy = document.createElement('span');
      const strong = document.createElement('strong');
      strong.textContent = label;
      copy.appendChild(strong);
      if (meta) {
        const small = document.createElement('small');
        small.textContent = meta;
        copy.appendChild(small);
      }
      link.appendChild(copy);
      panel.appendChild(registerOption(link));
    };
    const renderQuickLinks = () => {
      panel.replaceChildren();
      clearActiveOption();
      addHeading('Popular destinations');
      QUICK_LINKS.forEach((item) => addLink(item.label, item.url));
      open();
      announce(optionLinks().length + ' popular search destinations available.');
    };
    const renderResults = (data, query) => {
      panel.replaceChildren();
      clearActiveOption();
      const results = data?.resources?.results || {};
      const normalizedLabelQuery = normalizeShopifyQuery(query);
      const labelSizeIntent = isLabelSizeQuery(query);
      const sizeParts = normalizedLabelQuery.match(/(\d+(?:\.\d+)?)\s+x\s+(\d+(?:\.\d+)?)/i);
      const exactSizePhrase = sizeParts ? sizeParts[1] + ' x ' + sizeParts[2] : '';
      let products = Array.from(results.products || [])
        .filter((product) => (!exactSizePhrase || normalizeShopifyQuery(product.title).toLowerCase().includes(exactSizePhrase.toLowerCase())) && (!findExactPrinter(query) || (product.url || '').split('?')[0] !== findExactPrinter(query).url));
      if (labelSizeIntent && !/\bthermal\b/i.test(query)) {
        const inkjetProducts = products.filter((product) => /\binkjet labels?\b/i.test(product.title || ''));
        if (inkjetProducts.length) products = inkjetProducts;
      }
      products = products.sort((a, b) => searchScore(a, query) - searchScore(b, query)).slice(0, 10);
      const destinations = Array.from(new Map([...(results.collections || []).slice(0, 2), ...(results.articles || []).slice(0, 2), ...(results.pages || []).slice(0, 2)].map((item) => [(item.url || '').split('?')[0], item])).values()).slice(0, 6);
      const exactPrinter = findExactPrinter(query);
      const featuredDetails = Array.from(data?.ffProductDetails || []).filter(Boolean);
      const sourceProducts = Array.from(results.products || []).concat(featuredDetails);
      const exactPrinterProduct = exactPrinter ? sourceProducts.find((product) => productPath(product) === exactPrinter.url) : null;
      if (exactPrinter?.model === 'd3800' && !products.some((product) => productPath(product) === '/products/epson-cw-d3800-cmyk-ink-set-maintenance-box-kit-sjic56p')) {
        const kitDetail = featuredDetails.find((product) => product.handle === 'epson-cw-d3800-cmyk-ink-set-maintenance-box-kit-sjic56p');
        products.unshift(kitDetail ? { ...kitDetail, url: '/products/' + kitDetail.handle, type: kitDetail.type || 'Ink + maintenance kit' } : { title: 'Epson CW-D3800 CMYK Ink Set + Maintenance Box Kit - SJIC56P', url: '/products/epson-cw-d3800-cmyk-ink-set-maintenance-box-kit-sjic56p', type: 'Ink + maintenance kit' });
      }
      const closePrinters = exactPrinter ? [] : findClosestPrinters(query);
      if (exactPrinter) {
        addHeading('Exact printer match');
        addLink(exactPrinter.label, exactPrinter.url, exactPrinter.meta || 'Compatible inkjet label rolls', productImageUrl(exactPrinterProduct) || data?.ffCollectionImages?.[exactPrinter.url]);
      }
      if (closePrinters.length) {
        addHeading('Closest printer matches');
        closePrinters.forEach((item) => addLink(item.label, item.url, item.meta || 'Compatible inkjet label rolls'));
      }
      if (products.length) {
        if (!exactPrinter) addHeading('Matching products');
        if (exactPrinter) {
          const inkRank = (product) => { const title = String(product.title || ''); if (/cmyk.*set.*maintenance|maintenance.*cmyk/i.test(title)) return 0; if (/cmyk.*set|4\s*cartridges/i.test(title)) return 1; if (/ink|cartridge|sjic/i.test(title)) return 2; return 3; };
          const inkProducts = products.filter((product) => /\bink\b|cartridge|sjic|maintenance|cmyk/i.test(product.title || '')).sort((a, b) => inkRank(a) - inkRank(b));
          const labelProducts = products.filter((product) => /labels?|rolls?|bopp|paper/i.test(product.title || '') && !/printer/i.test(product.title || '') && !inkProducts.includes(product));
          const otherProducts = products.filter((product) => !inkProducts.includes(product) && !labelProducts.includes(product));
          if (inkProducts.length) {
            addHeading('Inks and maintenance');
            inkProducts.forEach((product) => addLink(product.title, product.url, exactPrinter.model === 'd3800' && String(product.url || '').includes('/products/epson-cw-d3800-') ? 'Coming Soon · ' + (product.type || 'Printer supply') : (product.type || 'Printer supply'), productImageUrl(product)));
          }
          if (labelProducts.length) {
            addHeading('Compatible labels');
            labelProducts.forEach((product) => addLink(product.title, product.url, product.type || 'Compatible label', productImageUrl(product)));
          }
          if (otherProducts.length) {
            addHeading('More matching products');
            otherProducts.forEach((product) => addLink(product.title, product.url, product.type || 'Product', productImageUrl(product)));
          }
        } else {
          products.forEach((product) => addLink(product.title, product.url, product.type || 'Product', productImageUrl(product)));
        }
      }
      if (destinations.length) {
        addHeading('Collections, articles and helpful pages');
        destinations.forEach((item) => addLink(item.title, item.url, item.type || 'Learn more', productImageUrl(item) || data?.ffCollectionImages?.[productPath(item)]));
      }
      if (!products.length && !destinations.length && !exactPrinter && !closePrinters.length && !labelSizeIntent) {
        addHeading('Need a hand?');
        addLink('Use the Label & Ink Finder', '/pages/inkjet-label-ink-finder', 'Match supplies to your printer');
      }
      const all = document.createElement('a');
      all.className = 'ffx-search-results__all';
      all.href = '/pages/smart-finder?q=' + encodeURIComponent(exactPrinter?.searchQuery || normalizedLabelQuery);
      all.textContent = 'Open the full Smart Finder result for “' + query + '”';
      panel.appendChild(registerOption(all));
      open();
      announce(optionLinks().length + ' search suggestions available. Use the up and down arrow keys to review them.');
    };
    const uniqueResults = (items) => Array.from(new Map(Array.from(items || []).map((item) => [productPath(item) || normalizeSearchText(item?.title), item])).values());
    const resultMeta = (kind, item) => {
      if (kind === 'printer') return item.type || 'Colour label printer';
      if (kind === 'ink' || kind === 'maintenance') return item.type || 'Printer supply';
      if (kind === 'labels') return item.type && !/compatible/i.test(item.type) ? item.type : 'Matching label';
      if (kind === 'equipment') return item.type || 'Printer accessory';
      return item.type || 'Product';
    };
    const sortByStrength = (items, analysis, kind) => Array.from(items || []).sort((left, right) => {
      const relevance = Intelligence.itemRelevance(right, analysis) - Intelligence.itemRelevance(left, analysis);
      if (relevance) return relevance;
      if (kind === 'ink' || kind === 'maintenance') {
        const supplyRank = (item) => {
          const title = String(item.title || '');
          if (/cmyk.*set.*maintenance|maintenance.*cmyk/i.test(title)) return 0;
          if (/cmyk.*set|4\s*cartridges/i.test(title)) return 1;
          if (/maintenance|sjmb/i.test(title)) return 2;
          return 3;
        };
        const rank = supplyRank(left) - supplyRank(right);
        if (rank) return rank;
      }
      return String(left.title || '').localeCompare(String(right.title || ''));
    });
    const mergeSuggestionPayloads = (payloads) => {
      const merged = { resources: { results: { products: [], collections: [], pages: [], articles: [] } } };
      payloads.forEach((payload) => {
        const results = payload?.resources?.results || {};
        Object.keys(merged.resources.results).forEach((key) => merged.resources.results[key].push(...Array.from(results[key] || [])));
      });
      Object.keys(merged.resources.results).forEach((key) => { merged.resources.results[key] = uniqueResults(merged.resources.results[key]); });
      return merged;
    };
    const renderIntentResults = (data, query) => {
      panel.replaceChildren();
      clearActiveOption();
      const analysis = Intelligence.analyzeQuery(query);
      const exactPrinter = analysis.printer;
      const results = data?.resources?.results || {};
      let products = uniqueResults(results.products || []);
      const continuousSpec = Intelligence.continuousLabelSpec?.(query);
      if (analysis.intent === 'labels' && continuousSpec) products = products.filter((item) => Intelligence.matchesContinuousLabel(item, continuousSpec));
      if (exactPrinter) products = products.filter((item) => Intelligence.itemRelevance(item, analysis) > 0);

      const groups = { printer: [], ink: [], maintenance: [], labels: [], equipment: [], other: [] };
      products.forEach((item) => {
        const kind = Intelligence.classifyItem(item, 'product');
        (groups[kind] || groups.other).push(item);
      });
      Object.keys(groups).forEach((kind) => { groups[kind] = sortByStrength(groups[kind], analysis, kind); });

      const addProductGroup = (heading, kinds, limit) => {
        const items = uniqueResults(kinds.flatMap((kind) => groups[kind] || [])).slice(0, limit);
        if (!items.length) return;
        addHeading(heading);
        items.forEach((item) => {
          const kind = Intelligence.classifyItem(item, 'product');
          addLink(item.title, productPath(item), resultMeta(kind, item), productImageUrl(item));
        });
      };
      const addExactLabelCollection = (heading = 'Compatible labels') => {
        if (!exactPrinter?.collection) return;
        addHeading(heading);
        addLink(
          Intelligence.labelCollectionTitle(exactPrinter),
          exactPrinter.collection,
          exactPrinter.generalCollection ? 'Browse the complete inkjet label collection' : exactPrinter.brand + ' compatible labels',
          data.ffCollectionImages?.[exactPrinter.collection]
        );
      };
      const addLabels = (collectionHeading = 'Compatible labels') => {
        addExactLabelCollection(collectionHeading);
        const labelProducts = groups.labels.slice(0, 6);
        labelProducts.forEach((item) => addLink(item.title, productPath(item), resultMeta('labels', item), productImageUrl(item)));
      };

      if (exactPrinter) {
        Intelligence.resultOrder(analysis.intent).forEach((group) => {
          if (group === 'printer') addProductGroup('Printer', ['printer'], 3);
          if (group === 'supplies') addProductGroup('Inks and maintenance', analysis.intent === 'maintenance' ? ['maintenance', 'ink'] : ['ink', 'maintenance'], 8);
          if (group === 'labels') addLabels(analysis.intent === 'labels' ? 'Exact label collection' : 'Compatible labels');
          if (group === 'equipment') addProductGroup('Printer accessories', ['equipment'], 6);
          if (group === 'other') addProductGroup('More matching products', ['other'], 4);
        });
      } else {
        const ordered = uniqueResults(products).sort((left, right) => Intelligence.itemRelevance(right, analysis) - Intelligence.itemRelevance(left, analysis)).slice(0, 10);
        if (ordered.length) {
          addHeading('Matching products');
          ordered.forEach((item) => {
            const kind = Intelligence.classifyItem(item, 'product');
            addLink(item.title, productPath(item), resultMeta(kind, item), productImageUrl(item));
          });
        }
        const closePrinters = findClosestPrinters(query);
        if (closePrinters.length) {
          addHeading('Closest printer matches');
          closePrinters.forEach((item) => addLink(item.label, item.url, item.meta));
        }
      }

      const content = uniqueResults([
        ...Array.from(results.collections || []).filter((item) => productPath(item) !== exactPrinter?.collection),
        ...Array.from(results.pages || []),
        ...Array.from(results.articles || [])
      ]).slice(0, 6);
      if (content.length) {
        addHeading('Collections, articles and helpful pages');
        content.forEach((item) => addLink(item.title, productPath(item), item.type || 'Learn more', productImageUrl(item) || data.ffCollectionImages?.[productPath(item)]));
      }

      if (!optionLinks().length) {
        addHeading('Need a hand?');
        addLink('Use the Label & Ink Finder', '/pages/inkjet-label-ink-finder', 'Match supplies to your printer');
      }
      const all = document.createElement('a');
      all.className = 'ffx-search-results__all';
      all.href = '/pages/smart-finder?q=' + encodeURIComponent(analysis.cleaned || query);
      all.textContent = 'Open the full Smart Finder result for “' + query + '”';
      panel.appendChild(registerOption(all));
      open();
      announce(optionLinks().length + ' search suggestions available. Use the up and down arrow keys to review them.');
    };
    const predictiveRequest = async (searchQuery, types, limit) => {
      const params = new URLSearchParams();
      params.set('q', searchQuery);
      params.set('resources[type]', types);
      params.set('resources[limit]', String(limit || 10));
      params.set('resources[options][unavailable_products]', 'show');
      const response = await fetch('/search/suggest.json?' + params.toString(), { signal: requestController.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Search request failed');
      return response.json();
    };
    const fetchIntentSuggestions = async (query) => {
      requestController?.abort();
      requestController = new AbortController();
      const analysis = Intelligence.analyzeQuery(query);
      const normalizedQuery = isLabelSizeQuery(query) ? exactSizeSearchQuery(query) : normalizeShopifyQuery(query);
      const baseQuery = analysis.printer ? Intelligence.canonicalPrinterQuery(analysis) : normalizedQuery;
      const requestPlan = [{ query: baseQuery, types: 'product,collection,page,article', limit: 10 }];
      if (analysis.printer) {
        if (analysis.intent === 'labels') requestPlan.push({ query: baseQuery + ' labels', types: 'product', limit: 10 });
        else if (analysis.intent === 'ink' || analysis.intent === 'maintenance' || analysis.intent === 'supplies') requestPlan.push({ query: baseQuery + ' ink maintenance', types: 'product', limit: 10 });
        else if (analysis.intent === 'equipment') requestPlan.push({ query: baseQuery + ' rewinder unwinder', types: 'product', limit: 10 });
        else requestPlan.push(
          { query: baseQuery + ' ink maintenance', types: 'product', limit: 10 },
          { query: baseQuery + ' labels', types: 'product', limit: 10 },
          { query: baseQuery + ' rewinder unwinder', types: 'product', limit: 10 }
        );
      }
      const cacheKey = requestPlan.map((item) => item.query + '|' + item.types).join('::').toLowerCase();
      if (suggestionCache.has(cacheKey)) { renderIntentResults(suggestionCache.get(cacheKey), query); return; }
      input.setAttribute('aria-busy', 'true');
      announce('Loading search suggestions.');
      try {
        const payloads = await Promise.all(requestPlan.map((item) => predictiveRequest(item.query, item.types, item.limit)));
        const payload = mergeSuggestionPayloads(payloads);
        payload.ffAnalysis = analysis;
        const printerDetails = await Promise.all(Array.from(analysis.printer?.productHandles || []).map(loadProductDetail));
        payload.resources.results.products = uniqueResults([
          ...printerDetails.filter(Boolean),
          ...payload.resources.results.products
        ]);
        const collectionUrls = [
          ...(analysis.printer?.collection ? [analysis.printer.collection] : []),
          ...Array.from(payload.resources.results.collections || []).map((item) => productPath(item))
        ].filter((url, index, urls) => url && urls.indexOf(url) === index);
        const collectionImageEntries = await Promise.all(collectionUrls.map(async (url) => [url, await loadCollectionImage(url)]));
        payload.ffCollectionImages = Object.fromEntries(collectionImageEntries.filter((entry) => entry[1]));
        suggestionCache.set(cacheKey, payload);
        if (suggestionCache.size > 24) suggestionCache.delete(suggestionCache.keys().next().value);
        renderIntentResults(payload, query);
      } catch (error) {
        if (error.name !== 'AbortError') { announce('Search suggestions are temporarily unavailable.'); renderQuickLinks(); }
      } finally {
        input.setAttribute('aria-busy', 'false');
      }
    };
    const fetchSuggestions = async (query) => {
      requestController?.abort();
      requestController = new AbortController();
      const params = new URLSearchParams();
      const exactPrinter = findExactPrinter(query);
      const canonicalQuery = exactPrinter?.searchQuery || (isLabelSizeQuery(query) ? exactSizeSearchQuery(query) : normalizeShopifyQuery(query));
      const cacheKey = canonicalQuery.toLowerCase();
      if (suggestionCache.has(cacheKey)) { renderResults(suggestionCache.get(cacheKey), query); return; }
      params.set('q', canonicalQuery);
      params.set('resources[type]', 'product,collection,page,article');
      params.set('resources[limit]', '10');
      params.set('resources[options][unavailable_products]', 'show');
      input.setAttribute('aria-busy', 'true');
      announce('Loading search suggestions.');
      try {
        const detailHandles = exactPrinter?.model === 'd3800' ? ['epson-colorworks-cw-d3800-color-label-printer', 'epson-cw-d3800-cmyk-ink-set-maintenance-box-kit-sjic56p'] : [];
        const detailsRequest = Promise.all(detailHandles.map(loadProductDetail));
        const response = await fetch('/search/suggest.json?' + params.toString(), { signal: requestController.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search request failed');
        const payload = await response.json();
        const collectionUrls = [
          ...(exactPrinter?.url?.startsWith('/collections/') ? [exactPrinter.url] : []),
          ...Array.from(payload?.resources?.results?.collections || []).map((item) => productPath(item))
        ].filter((url, index, urls) => url && urls.indexOf(url) === index);
        const [details, collectionImageEntries] = await Promise.all([
          detailsRequest,
          Promise.all(collectionUrls.map(async (url) => [url, await loadCollectionImage(url)]))
        ]);
        payload.ffProductDetails = details.filter(Boolean);
        payload.ffCollectionImages = Object.fromEntries(collectionImageEntries.filter((entry) => entry[1]));
        suggestionCache.set(cacheKey, payload);
        if (suggestionCache.size > 24) suggestionCache.delete(suggestionCache.keys().next().value);
        renderResults(payload, query);
      } catch (error) {
        if (error.name !== 'AbortError') { announce('Search suggestions are temporarily unavailable.'); renderQuickLinks(); }
      } finally {
        input.setAttribute('aria-busy', 'false');
      }
    };
    input.addEventListener('focus', () => { if (input.value.trim().length < 2) renderQuickLinks(); });
    input.addEventListener('input', () => {
      window.clearTimeout(debounceTimer);
      panel.replaceChildren();
      const query = input.value.trim();
      if (query.length < 2) { renderQuickLinks(); return; }
      debounceTimer = window.setTimeout(() => fetchIntentSuggestions(query), 220);
    });
    input.addEventListener('keydown', (event) => {
      const options = optionLinks();
      if (event.key === 'Escape') { close(); return; }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (panel.hidden && options.length) open();
        const nextIndex = event.key === 'ArrowDown' ? activeOptionIndex + 1 : (activeOptionIndex < 0 ? options.length - 1 : activeOptionIndex - 1);
        setActiveOption(nextIndex);
        return;
      }
      if (event.key === 'Home' && !panel.hidden && options.length) { event.preventDefault(); setActiveOption(0); return; }
      if (event.key === 'End' && !panel.hidden && options.length) { event.preventDefault(); setActiveOption(options.length - 1); return; }
      if (event.key === 'Enter' && activeOptionIndex >= 0 && options[activeOptionIndex]) {
        event.preventDefault();
        options[activeOptionIndex].click();
      }
    });
    form.addEventListener('submit', (event) => {
      const query = input.value.trim();
      if (!query) {
        event.preventDefault();
        input.focus();
        renderQuickLinks();
        return;
      }
      const exactPrinter = findExactPrinter(query);
      if (exactPrinter) {
        event.preventDefault();
        const analysis = Intelligence ? Intelligence.analyzeQuery(query) : null;
        window.location.assign('/pages/smart-finder?q=' + encodeURIComponent(analysis?.cleaned || query));
        return;
      }
      const normalizedQuery = normalizeShopifyQuery(query);
      if (Intelligence?.continuousLabelSpec?.(query)) {
        event.preventDefault();
        window.location.assign('/pages/smart-finder?q=' + encodeURIComponent(normalizedQuery));
        return;
      }
      if (isLabelSizeQuery(query)) {
        event.preventDefault();
        window.location.assign('/collections/inkjet-labels?ff_q=' + encodeURIComponent(query) + '#browse-labels');
        return;
      }
      if (normalizedQuery !== query) input.value = normalizedQuery;
    });
    document.addEventListener('click', (event) => { if (!form.contains(event.target) && !panel.contains(event.target)) close(); });
  }

  function initHeader(header) {
    if (header.dataset.ffHeaderReady === 'true') return;
    header.dataset.ffHeaderReady = 'true';

    const details = Array.from(header.querySelectorAll('[data-ff-nav-detail]'));
    const openButton = header.querySelector('[data-ff-mobile-open]');
    const drawer = header.querySelector('[data-ff-mobile-drawer]');
    const closeButtons = Array.from(header.querySelectorAll('[data-ff-mobile-close]'));
    header.querySelectorAll('[data-ff-search-form]').forEach(initSearch);

    const mobileSearchWrap = header.querySelector('.ffx-mobile-search-wrap');
    const mobileSearchOriginalParent = mobileSearchWrap?.parentElement;
    const mobileSearchOriginalNext = mobileSearchWrap?.nextSibling;
    let mobileSearchHost;

    const syncMobileSearchPlacement = () => {
      if (!mobileSearchWrap || !mobileSearchOriginalParent) return;
      if (window.innerWidth <= 989) {
        if (!mobileSearchHost) {
          mobileSearchHost = document.createElement('div');
          mobileSearchHost.className = 'ffx-mobile-search-host';
        }
        if (!mobileSearchHost.isConnected) header.querySelector('.ffx-header__main')?.after(mobileSearchHost);
        if (mobileSearchWrap.parentElement !== mobileSearchHost) mobileSearchHost.appendChild(mobileSearchWrap);
      } else if (mobileSearchWrap.parentElement !== mobileSearchOriginalParent) {
        if (mobileSearchOriginalNext?.parentElement === mobileSearchOriginalParent) {
          mobileSearchOriginalParent.insertBefore(mobileSearchWrap, mobileSearchOriginalNext);
        } else {
          mobileSearchOriginalParent.appendChild(mobileSearchWrap);
        }
        mobileSearchHost?.remove();
      }
    };

    syncMobileSearchPlacement();
    window.addEventListener('resize', syncMobileSearchPlacement, { passive: true });

    details.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        details.forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest?.('[data-ff-nav-detail]')) return;
      details.forEach((detail) => detail.removeAttribute('open'));
    });

    const setDrawer = (open, restoreFocus = true) => {
      if (!drawer || !openButton) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('ffx-menu-open', open);
      if (open) {
        window.setTimeout(() => drawer.querySelector('.ffx-mobile-drawer__head button')?.focus(), 60);
      } else if (restoreFocus && openButton.offsetParent !== null) {
        openButton.focus({ preventScroll: true });
      }
    };

    openButton?.addEventListener('click', () => setDrawer(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setDrawer(false)));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab' && drawer?.classList.contains('is-open')) {
        const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary'))
          .filter((element) => element.offsetParent !== null);
        if (focusable.length) {
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }
      if (event.key !== 'Escape') return;
      details.forEach((detail) => detail.removeAttribute('open'));
      if (drawer?.classList.contains('is-open')) setDrawer(false);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 989 && drawer?.classList.contains('is-open')) setDrawer(false, false);
    }, { passive: true });
  }

  let accountOverlayObserver;

  function initAccountOverlayAccessibility() {
    if (accountOverlayObserver) return;

    const syncOverlay = () => {
      const overlay = document.querySelector('cad-overlay');
      if (!overlay) return;
      
      
      const isOpen = overlay.classList.contains('open');
      const closeButton = overlay.querySelector('.cad-overlay__close button');

      if (closeButton && !closeButton.getAttribute('aria-label')) {
        closeButton.setAttribute('aria-label', 'Close sign in');
      }

      if (isOpen) {
        if (overlay.hasAttribute('inert')) overlay.removeAttribute('inert');
        if (overlay.getAttribute('aria-hidden') === 'true') overlay.setAttribute('aria-hidden', 'false');
      } else {
        if (!overlay.hasAttribute('inert')) overlay.setAttribute('inert', '');
        if (overlay.getAttribute('aria-hidden') !== 'true') overlay.setAttribute('aria-hidden', 'true');
      }
    };

    accountOverlayObserver = new MutationObserver(syncOverlay);
    accountOverlayObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open'] });
    document.addEventListener('click', () => window.requestAnimationFrame(syncOverlay), true);
    window.addEventListener('resize', syncOverlay, { passive: true });
    syncOverlay();
  }

  function initPrinterCollectionCards(scope = document) {
    if (!location.pathname.startsWith('/collections/')) return;
    if (!/(printer|colorworks)/i.test(location.pathname)) return;

    document.documentElement.classList.add('ff-printer-collection');
    scope.querySelectorAll('.card-action a.button-ATC[href*="/products/"]').forEach((link) => {
      const card = link.closest('.card');
      const title = card?.querySelector('.card-title')?.textContent?.trim();
      link.textContent = 'View details';
      if (title) link.setAttribute('aria-label', `View details for ${title}`);
    });
  }

  function normalizePageSemantics(scope = document) {
    if (location.pathname !== '/pages/contact-us') return;
    scope.querySelectorAll('h1.ffl-hero-title').forEach((heading) => {
      const replacement = document.createElement('h2');
      [...heading.attributes].forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });
  }

  function initFinalHomeCta(scope = document) {
    if (location.pathname !== '/') return;
    const selector = '[id$=\"__image_banner_brtU3z\"]';
    const section = scope.matches?.(selector) ? scope : scope.querySelector(selector);
    if (!section || section.dataset.ffFinalCtaReady === 'true') return;

    const box = section.querySelector('.content-box');
    const heading = section.querySelector('.banner-heading');
    const eyebrow = section.querySelector('.banner-sub-title span');
    const description = section.querySelector('.banner-text');
    const buttons = section.querySelectorAll('.banner-button span');
    if (!box || !heading || !description) return;

    section.dataset.ffFinalCtaReady = 'true';
    section.classList.add('ff-final-cta');
    eyebrow && (eyebrow.textContent = 'CUSTOM LABEL ROLLS MADE IN MISSISSAUGA');
    heading.textContent = 'Tell us your printer. We’ll build the roll.';
    description.textContent = 'Share your printer model, label size, material and run quantity. A ForeFront specialist will confirm compatibility and recommend the right production option.';
    if (buttons[0]) buttons[0].textContent = 'Start my custom roll';
    if (buttons[1]) buttons[1].textContent = 'Shop ready made rolls';

    const copy = document.createElement('div');
    copy.className = 'ff-final-cta__copy';
    Array.from(box.children).forEach((child) => copy.appendChild(child));

    const proof = document.createElement('div');
    proof.className = 'ff-final-cta__proof';
    proof.setAttribute('aria-label', 'ForeFront custom roll advantages');
    ['Made in Mississauga', 'Printer compatibility checked', 'Runs sized to your needs'].forEach((text) => {
      const item = document.createElement('span');
      item.textContent = text;
      proof.appendChild(item);
    });
    copy.appendChild(proof);

    const details = document.createElement('aside');
    details.className = 'ff-final-cta__details';
    details.setAttribute('aria-label', 'Information needed for a custom roll quote');
    const detailItems = ['Printer model', 'Label dimensions', 'Material and finish', 'Required quantity'];
    details.innerHTML = '<p class=\"ff-final-cta__details-label\">START WITH FOUR DETAILS</p><h4>Everything we need to find the right fit.</h4><ol>' + detailItems.map((item) => '<li><span>' + item + '</span></li>').join('') + '</ol><p class=\"ff-final-cta__details-note\">A label specialist will review the specifications with you.</p>';

    box.append(copy, details);
  }

  const initAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(initHeader);
    initPrinterCollectionCards(scope);
    normalizePageSemantics(scope);
    initFinalHomeCta(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initAll(); initAccountOverlayAccessibility(); });
  } else {
    initAll();
    initAccountOverlayAccessibility();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
